import { component } from 'picoapp';
import app from 'app';

import { getCart } from 'utils/cart';

import ProductMedia from 'layout/product-media';
import ProductRecommendations from 'layout/product-recommendations';
import ProductDescription from 'layout/product-description';
import ProductCountdown from 'layout/product-countdown';
import Lightbox from 'layout/lightbox';

const Product = component((node, ctx) => {
  const form = node.querySelector('[data-form]');
  const sizeInputs = form ? form.querySelectorAll('input[name="size"]') : [];

  sizeInputs.forEach((input, index) => {
    input.addEventListener('change', () => {
      const select = form.querySelector('select[data-option="option2"]');

      select.selectedIndex = index;
      select.dispatchEvent(new Event('change'));
    });
  });

  /* Klaviyo trigger */
  const klaviyoModalTrigger = node.querySelector('[data-trigger-modal]');
  if (klaviyoModalTrigger) {
    klaviyoModalTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('klaviyo:modal', { detail: { id: klaviyoModalTrigger.dataset.triggerModal } }));
    });
  }

  const data = JSON.parse(node.querySelector('.js-data').innerHTML);

  const initOptions = () => {
    const submit = node.querySelector('[data-submit]');
    const price = node.querySelector('[data-price]');
    const compareAtPrice = node.querySelector('[data-compare-price]');
    const BIS = node.querySelector('[data-bis]');

    const callback = (variant) => {
      if (variant) {
        price.innerHTML = Shopify.formatMoney(variant.price, theme.moneyFormat);

        if (variant.compare_at_price > variant.price) {
          compareAtPrice.hidden = false;
          const variantPrice = variant.compare_at_price;
          compareAtPrice.innerHTML = Shopify.formatMoney(variantPrice, theme.moneyFormat);
        } else {
          compareAtPrice.hidden = true;
        }

        if (variant.available) {
          submit.innerHTML = theme.strings.addToCart;
          submit.disabled = false;
          submit.hidden = false;
          BIS.hidden = true;
          BIS.style.display = 'none';
        } else {
          submit.innerHTML = theme.strings.soldOut;
          submit.disabled = true;
          submit.hidden = true;
          BIS.hidden = false;
          BIS.style.display = 'inline-flex';
        }
      } else {
        submit.innerHTML = theme.strings.unavailable;
        submit.disabled = true;
        submit.hidden = true;
        BIS.hidden = false;
        BIS.style.display = 'inline-flex';
      }
    };

    const init = () => new Shopify.OptionSelectors(`product-${data.id}`, {
      product: data,
      onVariantSelected: callback,
      enableHistoryState: true,
    });

    init();
  };

  const handleSubmit = () => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const formData = new FormData(form);

      const response = await fetch(`${form.action}.js`, {
        method: form.method,
        body: formData,
      });

      const cartData = await getCart();
      ctx.emit('cart:updated', ({ cart: cartData }));

      document.dispatchEvent(new CustomEvent('product:added', {
        detail: { data: response },
      }));
    });
  };

  if (form) {
    initOptions();
    handleSubmit();
  }
});

app.add({
  Product,
  ProductMedia,
  ProductRecommendations,
  ProductDescription,
  ProductCountdown,
  Lightbox,
});

app.mount();
